import { get, post } from "@shared/core/io";
import { afterGateway } from "@shared/apis/gw-helper";

const USER_V1_API_PREFIX = "/gw/user/api/v1";

export function updateUserFav(productId, isAdd) {
  if (isAdd) {
    return post(`${USER_V1_API_PREFIX}/fav/add/${productId}`);
  }
  return post(`${USER_V1_API_PREFIX}/fav/del/${productId}`);
}

export function queryUserFavByProducts(productIds) {
  return post(`${USER_V1_API_PREFIX}/fav/queryFav`, {
    productIds,
  });
}

export function queryChatContent(data /* = { userId1, userId2 }*/) {
  return post(`${USER_V1_API_PREFIX}/order/session/content`, data);
}
export function queryChatStat(data /* = [{ userId1, userId2 }]*/) {
  return post(`${USER_V1_API_PREFIX}/order/sessions/stat`, data);
}

export function queryVerifyInfo(userId) {
  return afterGateway(get(`${USER_V1_API_PREFIX}/user/verifyInfo/${userId}`));
}

export function queryCertTypes() {
  return afterGateway(get(`${USER_V1_API_PREFIX}/certTypeList`));
}

export function verify(data) {
  return afterGateway(post(`${USER_V1_API_PREFIX}/verify`, data));
}

export default {
  updateUserFav,
  queryUserFavByProducts,
};
